import { Box, Flex } from "@chakra-ui/react";
import { FormProvider, useForm } from "react-hook-form";
import { Header } from "../../components/Header";
import { Form } from "./Form";
import { zodResolver } from "@hookform/resolvers/zod";
import { validationUsuarioNovo } from "../../schemas/usuario";

export function UsuarioNovo() {
  const form = useForm({
    resolver: zodResolver(validationUsuarioNovo)
  });

  return (
    <FormProvider {...form}>
      <Box
        display={"flex"}
        flexDir={"column"}
        justifyContent={"center"}
        width={"full"}
        alignItems={"center"}
      >
        <Flex
          maxWidth={"90%"}
          width={"100%"}
          flexDir={"column"}
          justifyContent={"center"}
        >
          <Header />
          <Box
            px={"1rem"}
            bg={"white"}
            w={"full"}
            display={"flex"}
            flexDir={"column"}
            gap={"8"}
            pb={8}
          >
            <Form />
          </Box>
        </Flex>
      </Box>
    </FormProvider>
  );
}
